import React from 'react'
import Learmores from '../component/LearnMOre/Learmore'

const Learnmore = () => {
  return (
    <div>
     <Learmores />
    </div>
  )
}

export default Learnmore
